const letsChatSports = (state = null, action) => {
  const { payload, type } = action;
  let idsList = [];

  switch (type) {
    case 'INITIAL_DATA':
      return state?.length ? [...state] : [];

    case 'ADD_LETS_CHAT_SPORTS_DATA':
      idsList = payload.map((x) => x?._id);
      return [...payload];

    case 'ADD_LETS_CHAT_SPORTS_ITEM':
      return [payload, ...state.filter((x) => payload._id !== x._id)];

    case 'APPEND_LETS_CHAT_SPORTS_DATA':
      idsList = payload.map((x) => x?._id);
      return [...state.filter((x) => !idsList.includes(x._id)), ...payload];

    case 'UPDATE_LETS_CHAT_SPORTS_ITEM':
      return state.map((chat) => {
        if (chat._id !== payload._id) return chat;

        return {
          ...chat,
          ...payload
        };
      });

    case 'INC_SPORT_CHAT_COMMENT_COUNT':
      return state.map((chat) => {
        if (chat._id !== payload.postId) return chat;

        return {
          ...chat,
          commentsCount: chat.commentsCount + 1
        };
      });

    default:
      return state;
  }
};

export default letsChatSports;
